export const days = [
  { label: 'S' },
  { label: 'T' },
  { label: 'Q' },
  { label: 'Q' },
  { label: 'S' },
  { label: 'S' },
  { label: 'D' },
];
